import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'rmt-card-new',
    templateUrl: 'rmt-card-new.html'
})

export class RmtCardNewComponent {
    onClickFunc;
    @Input() groupHeader: string = "";
    @Input() headerButton: string = "";
    @Input() onCardClick;
    @Input() transparentCard: boolean = false;
    @Input() showCTASkeleton: boolean = false;
    @Input() isSkeletonLoading: boolean = false;
    @Input() hasHeaderIcon: boolean = false;
    @Input() list: boolean = false;
    @Output() onHeaderButton = new EventEmitter<any>();
    @Output() onHeaderIcon = new EventEmitter<any>();
    

    constructor() {
        this.onClickFunc = () => {
            if(this.onCardClick)
                this.onCardClick();
        }
    }

    clickHeaderButton() {
        this.onHeaderButton.emit();
    }

    clickHeaderIcon() {
        this.onHeaderIcon.emit();
    }

}


// WEBPACK FOOTER //
// ./src/components/rmt-card-new/rmt-card-new.ts